import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import { di } from 'react-magnetic-di';
import { FormattedMessage } from 'react-intl-next';
import { Box, Inline } from '@atlaskit/primitives';
import AIIcon from '../../../../../common/ai-icon';
import { InfoIcon } from '../icons/info';
import { messages } from '../../../../../../messages';
import { useAISummary } from '../../../../../../state/hooks/use-ai-summary';
export const AIFooterMetadata = ({
  testId,
  url,
  ari,
  product
}) => {
  const {
    state: {
      status
    }
  } = useAISummary({
    url,
    ari,
    product
  });
  if (status !== 'done') {
    return null;
  }
  return /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    testId: testId,
    alignInline: "end",
    grow: "fill"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_summarized_info_short),
    position: "bottom"
  }, tooltipProps => /*#__PURE__*/React.createElement(Box, tooltipProps, /*#__PURE__*/React.createElement(InfoIcon, {
    label: "Information",
    size: "small",
    primaryColor: "var(--ds-icon-subtle, #626F86)"
  }))), /*#__PURE__*/React.createElement(AIIcon, {
    label: "AI",
    size: "small",
    primaryColor: "var(--ds-icon-subtle, #626F86)"
  }));
};